import { Box, Typography } from '@mui/material';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip as ChartTooltip, XAxis, YAxis } from 'recharts';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import React from 'react';
import moment from 'moment';

const ComplianceTrendChart = ({ trendData }: any) => {
  const { formatDate } = useDateService();

  return (
    <Box height="220px" mt={2}>
      <Typography variant="subtitle2" mb={1}>
        Compliance Trend
      </Typography>
      <ResponsiveContainer width="100%" height="85%">
        <AreaChart data={trendData} margin={{ top: 5, right: 5, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="2 2" />
          <XAxis
            tick={{ fontSize: 10 }}
            dataKey="date"
            minTickGap={0}
            interval={0}
            tickFormatter={(value, index) => {
              const currentLabel = moment(value).format('MMM');
              if (index === 0) {
                return currentLabel;
              }
              const previousLabel = moment(trendData[index - 1].date).format('MMM');
              return currentLabel === previousLabel ? '' : currentLabel;
            }}
          />
          <YAxis tick={{ fontSize: 10 }} domain={[0, 100]} unit="%" width={40} />
          <ChartTooltip
            wrapperStyle={{ fontSize: 10 }}
            formatter={(value: number, name: string, props: any) => {
              const { payload } = props;
              const prefix = payload.isOverCapacity ? 'Over by ' : '';
              return [`${prefix}${value}%`, 'Fulfillment'];
            }}
            labelFormatter={(_, data) => {
              const activeItem = data[0];
              if (activeItem && activeItem.payload) {
                const { date } = activeItem.payload;
                return `${formatDate(date, DATE_FORMAT.FULL_DATE)}`;
              }
              return '';
            }}
          />
          <Area
            type="monotone"
            dataKey="absolutePercentage"
            stroke="var(--mui-palette-primary-main)"
            fill="var(--mui-palette-primary-main)"
            name="Fulfillment"
            fillOpacity={0.6}
            strokeWidth={2}
            strokeOpacity={1}
            connectNulls={false}
            width={25}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
};
export default ComplianceTrendChart;
